import React, { useEffect, useState } from 'react'
import {Input,Button} from "@material-tailwind/react"
import { useNavigate } from "react-router-dom";
import { db } from "../firebase.config";
import {
  doc,
  setDoc,
  addDoc,
  collection,
  where,
  query,
  getDoc,
  getDocs,
} from "firebase/firestore";
import { InformationCircleIcon, EyeIcon,EyeSlashIcon, PhoneIcon } from '@heroicons/react/24/outline';
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, loadUser, login, loginUsingEmail } from "../actions/userActions";
const Login = () => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const dispatch = useDispatch();
  const { error, loading, isAuthenticated, numberAdded } = useSelector(
    (state) => state.user
  );

  const navigate = useNavigate();
    const handleLogin = () =>{
      dispatch(loginUsingEmail(email,password))
    }


  
  useEffect(() => {
    if (error) {
      dispatch(clearErrors());
    }

    if (isAuthenticated) {
      
      navigate("/");
    }
  }, [dispatch, error, alert, isAuthenticated, navigate]);
  return (
    <div className='bg-gray-200 h-[100vh] flex items-center justify-center ' >
        <div className='bg-white rounded-lg py-6 px-6' >
            <h3 className='font-[NeueMedium] text-[2rem] text-center' >Login</h3>
            <div className='flex items-center justify-center flex-col' >
                <div className='my-2 w-full' >
                    <Input value={email} onChange={(e)=>setEmail(e.target.value)} type="email" label='Email Id' />
                </div>
                <div className="relative flex w-full ">
      <Input
        
        label="Password"
        value={password} 
        
        onChange={(e)=>{setPassword(e.target.value)}}
        type={showPassword ? "text" : "password"}
        className="pr-20 bg-white "
        containerProps={{
          className: "min-w-0",
        }}
      />
      <button
        
       
        disabled={!password}
        onClick={()=>setShowPassword(!showPassword)}
        className="!absolute  right-2 top-3 "
      >
        {showPassword ? <EyeIcon className='w-[15px]  text-blue-500' /> :<EyeSlashIcon className='w-[15px] text-blue-500' />}
      </button>
      
    </div>
                <div className='my-2' >
                    <Button onClick={handleLogin} >Login</Button>
                </div>
            </div>

        </div>
    </div>
  )
}

export default Login